import React, { useEffect, useState } from "react";
import AddButton from "../../../components/admin/usable/AddButton";
import CancelButton from "../../../components/admin/usable/CancelButton";

import Switch from "@mui/joy/Switch";
import CompanySelect from "../../../components/admin/usable/CompanySelect";
import toast from "react-hot-toast";
import { getSingleHotel, updateHotel } from "../../../api/admin/hotel";
import { useNavigate, useParams } from "react-router";

const ViewHotel = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [FormData, setFormData] = useState({
    hotelId: "",
    companyId: "",
    hotelName: "",
    hotelLogo: "",
    propertyStar: "",
    description: "",
    rooms: "",
    floors: "",
    foundedYear: "",
    area: "",
    city: "",
    division: "",
    country: "",
    isCoupleFriendly: 0,
    isFeatured: 0,
    isIdRequired: 0,
    checkIn: "",
    checkOut: "",
    isChildAllowed: 1,
    childPolicy: "",
    isPetAllowed: 0,
    petPolicy: "",
    hotelRules: "",
    isAcceptMasterCard: 0,
    isAcceptVisaCard: 0,
    isAcceptAmmexCard: 0,
    isAcceptDebitCard: 0,
    isAcceptCash: 0,
    isAcceptsMFS: 0,
    isDhoorbinChoice: 0,
    isCustomerChoice: 0,
    status: 1,
    created_by: 6,
    createdAt: new Date().toISOString(),
    facilities: [],
    images: [],
    nearBy: [],
  });
  const [CompanyId, setCompanyId] = useState("");

  const [ImageFile, setImageFile] = useState([]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      companyId: CompanyId,
    }));
  }, [CompanyId]);

  const handleSubmit = () => {
    navigate("/admin/hotels");
  };
  useEffect(() => {
    getSingleHotel(id, setFormData, setImageFile, setCompanyId);
  }, [id]);
  return (
    <>
      <div className="space-y-10">
        <div className="p-4 bg-white rounded-lg space-y-3">
          <div>
            <p className="font-bold text-center uppercase">Hotel Information</p>
          </div>
          <div className="grid grid-col-1 lg:grid-cols-3 gap-4">
            <div className="space-y-2">
              <div>
                <label className="text-xs" htmlFor="">
                  Company Name
                </label>
                <CompanySelect
                  CompanyId={CompanyId}
                  setCompanyId={setCompanyId}
                />
              </div>
              <div className="grid grid-col-1 lg:grid-cols-2 gap-2">
                <div>
                  <label className="text-xs" htmlFor="">
                    Area
                  </label>
                  <div
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                    placeholder="Area"
                  >
                    {FormData.area}
                  </div>
                </div>
                <div>
                  <label className="text-xs" htmlFor="">
                    City
                  </label>
                  <div
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                    placeholder="Area"
                  >
                    {FormData.city}
                  </div>
                </div>
                <div>
                  <label className="text-xs" htmlFor="">
                    Division
                  </label>
                  <div
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                    placeholder="Area"
                  >
                    {FormData.division}
                  </div>
                </div>
                <div>
                  <label className="text-xs" htmlFor="">
                    Country
                  </label>
                  <div
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                    placeholder="Area"
                  >
                    {FormData.country}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div>
                <label className="text-xs" htmlFor="">
                  Hotel Name
                </label>
                <div
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                  placeholder="Area"
                >
                  {FormData.hotelName}
                </div>
              </div>
              <div>
                <label className="text-xs" htmlFor="">
                  Description
                </label>
                <textarea
                  disabled
                  rows={5}
                  type="text"
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                  placeholder="Description"
                  id="description"
                  value={FormData.description}
                />
              </div>
            </div>
            <div className="space-y-3">
              <div className="grid grid-cols-3 gap-2">
                <div>
                  <label className="text-xs" htmlFor="">
                    Number of Rooms
                  </label>
                  <div
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                    placeholder="Area"
                  >
                    {FormData.rooms}
                  </div>
                </div>
                <div>
                  <label className="text-xs" htmlFor="">
                    Number of Floors
                  </label>
                  <div
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                    placeholder="Area"
                  >
                    {FormData.floors}
                  </div>
                </div>
                <div>
                  <label className="text-xs" htmlFor="">
                    Founded Year
                  </label>
                  <div
                    className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                    placeholder="Area"
                  >
                    {FormData.foundedYear}
                  </div>
                </div>
              </div>
              <div className="grid grid-col-1 lg:grid-cols-2 gap-2 ">
                <div className="grid-cols-2">
                  <div>
                    <label className="text-xs" htmlFor="">
                      Property Star
                    </label>

                    <div
                      className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                      placeholder="Area"
                    >
                      {FormData.propertyStar}{" "}
                      {FormData.propertyStar > 1 ? "Stars" : "Star"}
                    </div>
                  </div>
                  <div className="flex justify-start lg:justify-center items-center gap-2 ">
                    <div className="flex gap-1 ">
                      <div>
                        <label className="text-xs" htmlFor="">
                          CheckIn
                        </label>
                        <div className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm">
                          {FormData.checkIn}
                        </div>
                      </div>
                      <div>
                        <label className="text-xs" htmlFor="">
                          CheckOut
                        </label>
                        <div
                          className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                          placeholder="Area"
                        >
                          {FormData.checkOut}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="">
                  <label className="text-xs" htmlFor="">
                    Hotel Logo
                  </label>
                  <div className="relative w-full h-20">
                    <img
                      className="w-full h-20 object-contain rounded-lg"
                      src={
                        FormData.hotelLogo
                          ? FormData.hotelLogo
                          : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                      }
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-4 bg-white rounded-lg space-y-3">
          <div>
            <p className="font-bold text-center uppercase">Facilities</p>
          </div>
          <div className="grid grid-col-1 lg:grid-cols-3 gap-3">
            <div>
              {FormData.facilities.length > 0 ? (
                <>
                  <div className="space-y-3">
                    {FormData.facilities.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="border space-y-3 p-4 rounded-lg "
                        >
                          <div>
                            <p className="text-sm font-semibold">
                              {item.useFor}
                            </p>
                          </div>
                          <div className="flex justify-start items-end flex-wrap gap-3">
                            {item.facilities.map((facility, index) => {
                              return (
                                <div key={index}>
                                  <div className="flex justify-start items-center gap-x-2 border w-fit p-2 rounded-lg">
                                    <div className="w-5 h-5 overflow-hidden rounded-lg">
                                      <img
                                        className="w-full h-full object-cover"
                                        src={facility.icon}
                                        alt={facility.facilityName}
                                      />
                                    </div>

                                    <p className="text-xs">
                                      {facility.facilityName}
                                    </p>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              ) : (
                <div className="py-10 flex justify-center items-center">
                  <p className="text-sm text-black/50">
                    No Facilities Selected
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="p-4 bg-white rounded-lg space-y-3">
          <div>
            <p className="font-bold text-center uppercase">Near by places</p>
          </div>
          <div className="grid grid-col-1 lg:grid-cols-3 gap-5">
            {FormData.nearBy.length > 0 ? (
              <>
                {FormData.nearBy.map((item, index) => {
                  return (
                    <div key={index} className="p-2 rounded-lg border">
                      <div className="flex gap-x-5">
                        <div className="w-40 h-full overflow-hidden rounded-lg">
                          <img
                            className="w-full h-full object-cover"
                            src={item.image}
                            alt=""
                          />
                        </div>
                        <div className="space-y-2">
                          <p className="text-md font-bold">{item.placeName}</p>
                          <p className="text-sm text-black/60">
                            {item.description}
                          </p>
                          <p className="text-xs text-black/50">
                            Distance: {item.distance}
                          </p>
                          <p className="text-xs text-black/50">
                            Neighbourhood: {item.neighbourhood}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </>
            ) : (
              <div className="py-10 flex justify-center items-center">
                <p className="text-sm text-black/50">
                  No Near by place Selected
                </p>
              </div>
            )}
          </div>
        </div>
        <div className="p-4 bg-white rounded-lg space-y-3">
          <div>
            <p className="font-bold text-center uppercase">Features Toggle</p>
          </div>
          <div className="flex flex-wrap justify-center items-center gap-4">
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Couple Friendly?
              </label>
              <div>
                <Switch checked={FormData.isCoupleFriendly === 1} />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Featured?
              </label>
              <div>
                <Switch checked={FormData.isFeatured === 1} />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                ID card required?
              </label>
              <div>
                <Switch checked={FormData.isIdRequired === 1} />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Children allowed?
              </label>
              <div>
                <Switch checked={FormData.isChildAllowed === 1} />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Pet allowed?
              </label>
              <div>
                <Switch checked={FormData.isPetAllowed === 1} />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Mastercard allowed?
              </label>
              <div>
                <Switch checked={FormData.isAcceptMasterCard === 1} />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Visa allowed?
              </label>
              <div>
                <Switch checked={FormData.isAcceptVisaCard === 1} />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Cash allowed?
              </label>
              <div>
                <Switch checked={FormData.isAcceptCash === 1} />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                MFS allowed?
              </label>
              <div>
                <Switch checked={FormData.isAcceptsMFS === 1} />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Ammex Card allowed?
              </label>
              <div>
                <Switch checked={FormData.isAcceptAmmexCard === 1} />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Debit Card allowed?
              </label>
              <div>
                <Switch checked={FormData.isAcceptDebitCard === 1} />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Dhoorbin choice?
              </label>
              <div>
                <Switch checked={FormData.isDhoorbinChoice === 1} />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Customer Choice allowed?
              </label>
              <div>
                <Switch checked={FormData.isCustomerChoice === 1} />
              </div>
            </div>
          </div>
        </div>
        <div className="p-4 bg-white rounded-lg space-y-3">
          <div>
            <p className="font-bold text-center uppercase">Select Images</p>
          </div>
          <div>
            {FormData.images.length > 0 ? (
              <>
                <div className="flex justify-center flex-wrap items-center gap-3">
                  {FormData.images.map((item, index) => {
                    return (
                      <div key={index} className="relative w-28 h-28">
                        <img
                          className="w-28 h-28 object-cover rounded-lg"
                          src={
                            item.imageLink ||
                            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                          }
                          alt=""
                        />
                      </div>
                    );
                  })}
                </div>
              </>
            ) : (
              <>
                <div className="flex justify-center items-center text-xs">
                  <p>No images to show</p>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="p-4 bg-white rounded-lg space-y-3 ">
          <div>
            <p className="font-bold text-center uppercase">
              Rules and Policies
            </p>
          </div>
          <div className="grid grid-col-1 lg:grid-cols-2 gap-4">
            <div>
              <label htmlFor="" className="text-sm">
                Hotel Rules and Regulation
              </label>
              <div
                dangerouslySetInnerHTML={{ __html: FormData.hotelRules }}
                className="p-3 bg-[#f0f0f0] rounded-lg"
              />
            </div>
            {FormData.isChildAllowed === 1 && (
              <div>
                <label htmlFor="" className="text-sm">
                  Chidren Policy
                </label>
                <div
                  dangerouslySetInnerHTML={{ __html: FormData.childPolicy }}
                  className="p-3 bg-[#f0f0f0] rounded-lg"
                />
              </div>
            )}
            {FormData.isPetAllowed === 1 && (
              <div>
                <label htmlFor="" className="text-sm">
                  Pet Policy
                </label>
                <div
                  dangerouslySetInnerHTML={{ __html: FormData.petPolicy }}
                  className="p-3 bg-[#f0f0f0] rounded-lg"
                />
              </div>
            )}
          </div>
        </div>

        <div className="p-4 bg-white rounded-lg space-y-3">
          <div className="flex justify-center items-center gap-3">
            <AddButton
              onClick={() => navigate(`/admin/hotel/edit/${id}`)}
              text="Edit Now"
            />
            <CancelButton
              onClick={() => navigate(`/admin/hotels`)}
              text="Back"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewHotel;
